import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { AboutPageContent } from 'client/contents/AboutPageContent/AboutPageContent'

type TProps = {}

const AboutPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.AboutPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <AboutPageContent />
    </article>
  )
}

export default AboutPage
